import { render, staticRenderFns } from "./StaffDirectory.vue?vue&type=template&id=5880ec7b&scoped=true"
import script from "./StaffDirectory.ts?vue&type=script&lang=js&external"
export * from "./StaffDirectory.ts?vue&type=script&lang=js&external"
import style0 from "./StaffDirectory.scss?vue&type=style&index=0&id=5880ec7b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5880ec7b",
  null
  
)

export default component.exports